import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ButtonModule } from '../../../../shared/components/button/button.module';
import { DeleteAccountComponent } from './delete-account.component';

@NgModule({
	declarations: [DeleteAccountComponent],
	imports: [SharedModule, ButtonModule],
	exports: [DeleteAccountComponent],
})
export class DeleteAccountModule {}
